// Module
var code = "<div class=\"file-quick-actions\"> <mycrm-dropdown dropdown-text=\"'Quick Actions'\" menu-items=\"vm.menuItems\" on-menu-item-click=\"vm.onMenuItemClick({ data })\"></mycrm-dropdown> </div> ";
// Exports
module.exports = code;